import { useContext } from 'react';
import { Context } from '../context/context';

export const useDrawerVisibility = () => {
  const { state, dispatch } = useContext(Context);

  const setDrawerVisibility = (state) => {
    dispatch({ type: 'drawerState', payload: state });
  };

  return [setDrawerVisibility, state];
};
